module.exports = __webpack_public_path__ + "img/icon_result-fail.7626599c.svg";